import React from 'react';

import { Link } from 'react-router-dom';

import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { media } from '../../services/media';
import { themeStyles } from '../../services/themeStyles';

interface LogoProps {
    src: string;
}

export const Logo: React.FC<LogoProps> = ({ src }) => (
    <Link to="/" style={{ display: 'block', cursor: 'pointer', zIndex: 10 }}>
        <LogoImage src={src} />
    </Link>
);

const LogoImagePenge = themeStyles(
    'pengestyrke',
    css`
        ${media.max('md')} {
            width: 217px;
        }

        ${media.between('md', 'lg')} {
            width: 240px;
        }

        ${media.min('lg')} {
            width: 340px;
        }
    `,
);

const LogoImageFormue = themeStyles(
    'formue',
    css`
        width: 237px;
    `,
);

const LogoImageUpscore = themeStyles(
    'upscore',
    css`
        ${media.max('md')} {
            width: 123px;
        }
        ${media.between('md', 'lg')} {
            width: 190px;
        }

        ${media.min('lg')} {
            width: 264px;
        }
    `,
);

const LogoImage = styled.img`
    display: block;
    ${LogoImagePenge}
    ${LogoImageFormue}
    ${LogoImageUpscore}
`;
